<template>
  <WorkInformationDialog
    ref="employeeRequiredDialog"
    :message="$t('Dialogs.EmployeeRequiredDialog.message')"
    :description="$t('Dialogs.EmployeeRequiredDialog.description')"
  >
    <template #dialog-actions='{ close }'>
      <w-btn
        outlined
        @click='close'
      >
        {{ $t('Dialogs.ConfirmationDialog.confirm') }}
      </w-btn>
    </template>
  </WorkInformationDialog>
</template>

<script>
import WorkInformationDialog from '@/components/base_components/dialog/icon-dialogs/WorkInformationDialog';

export default {
  
  name: 'RequiredEmployeeDialog',
  components: { WorkInformationDialog },
  methods: {
    open() {
      return this.$refs.employeeRequiredDialog.open();
    },
  }
}
</script>